import { CountryCode, Customer } from '../pages/types';

export const isCanadianCustomer = (customer: Customer) => {
  return customer.default_country === CountryCode.CA;
};

export const getCountryFromCurrency = (currency: string | null): string | null => {
  if (currency === 'CAD') return CountryCode.CA;
  if (currency === 'USD') return CountryCode.US;
  return null;
};
